import React from "react";
import BaseComponent from 'Core/components/BaseComponent';
import PropTypes from "prop-types";
import Button, {BUTTON_DISPLAY_TYPE, BUTTON_STYLE} from 'Core/components/display/Button';
import {getIOUrl} from 'Core/io/helper';
import {rtrimString} from 'Core/helpers/string';
import {getString, trimArray} from 'Core/helpers/data';
import DownloadButton from 'Core/components/action/DownloadButton';
import Label from 'Core/components/display/Label';
import {openDialog} from 'Core/helpers/dialog';
import EFaxDialog from '../../Dialogs/EFaxDialog';
import {addErrorMessage} from 'Core/helpers/message';

class ReportItem extends BaseComponent {
	constructor(props) {
		super(props, {
			optimizedUpdate: true,
		});
		
		// eFax methods
		this.openEFaxDialog = this.openEFaxDialog.bind(this);
	}


	// eFax methods -----------------------------------------------------------------------------------------------------
	/**
	 * Opens the dialog for sending eFax messages.
	 */
	openEFaxDialog() {
		const {study, report} = this.props;
		
		const dialogGUIID = openDialog('', EFaxDialog, {
			report,
			study,
		}, {
			id: 'e-fax-dialog',
			className: 'bordered-title',
			closeOnEscape: false,
			closeOnClickOutside: false,
			hideCloseBtn: false,
			maxWidth: 480
		});
		this.setOption(
			'dialogsToCloseOnUnmount',
			trimArray([...this.getOption('dialogsToCloseOnUnmount'), dialogGUIID], 'left')
		);
	}
	
	
	// Render methods ---------------------------------------------------------------------------------------------------
	render() {
		const {className, dropdownRef, report, study} = this.props;
		
		return (
			<div className={`reports-dropdown-item ${className}`}>
				<span className="reports-dropdown-item-label" data-label={true}>
					<Label icon="page" iconSymbolPrefix="icofont-" content={report} />
				</span>
				<Button
					className="reports-dropdown-item-action"
					label="eFax"
					displayType={BUTTON_DISPLAY_TYPE.TRANSPARENT}
					displayStyle={BUTTON_STYLE.ACTION}
					onClick={() => {
						if (!!dropdownRef?.current) dropdownRef.current.closeDropdown();
						this.openEFaxDialog();
					}}
				/>
				<DownloadButton
					id={report}
					className="reports-dropdown-item-action"
					icon=""
					label={this.t('Download', 'general')}
					displayType={BUTTON_DISPLAY_TYPE.TRANSPARENT}
					displayStyle={BUTTON_STYLE.ACTION}
					url={getIOUrl('defaultAuthorizedApi', 'study/read-report')}
					filename={rtrimString(getString(report), '.enc2')}
					data={{
						id: study.id,
						file: report,
					}}
					onDownload={() => {
						if (!!dropdownRef?.current) dropdownRef.current.closeDropdown();
					}}
					onDownloadError={e => {
						if (getString(e, 'message')) addErrorMessage(e.message);
						else addErrorMessage(`${this.t('Error', 'general')}!`);
					}}
				/>
			</div>
		);
	}
}

/**
 * Define the component's own props that can be passed to it by parent components
 */
ReportItem.propTypes = {
	className: PropTypes.string,
	dropdownRef: PropTypes.object.isRequired,
	report: PropTypes.string.isRequired,
	study: PropTypes.object.isRequired,
};

/**
 * Define component default values for own props
 */
ReportItem.defaultProps = {
	className: '',
};

export default ReportItem;